<template>
  <div class="form-row">
    <div class="col-sm-6">
      <div class="form-group">
        <div class="form-row">
          <label class="col-form-label col-6">Home penalties</label>
          <div class="col">
            <button class="btn btn-block btn-primary" @click="newHomePenalty(2)">2'</button>
          </div>
          <div class="col">
            <button class="btn btn-block btn-primary" @click="newHomePenalty(5)">5'</button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="form-row" v-for="p in homePenalties">
          <div class="col-3">
            <time-input-group v-model="p.startTimeMs" label=""></time-input-group>
          </div>
          <div class="col-3">
            <time-input-group v-model="p.duration" label=""></time-input-group>
          </div>
          <div class="col-3">
            <button class="btn btn-block btn-primary" @click="updateHomePenalty(p)">Update</button>
          </div>
          <div class="col-3">
            <button class="btn btn-block btn-danger" @click="removeHomePenalty(p)">Remove</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="form-group">
        <div class="form-row">
          <label class="col-form-label col-6">Away penalties</label>
          <div class="col">
            <button class="btn btn-block btn-primary" @click="newAwayPenalty(2)">2'</button>
          </div>
          <div class="col">
            <button class="btn btn-block btn-primary" @click="newAwayPenalty(5)">5'</button>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="form-row" v-for="p in awayPenalties">
          <div class="col-3">
            <time-input-group v-model="p.startTimeMs" label=""></time-input-group>
          </div>
          <div class="col-3">
            <time-input-group v-model="p.duration" label=""></time-input-group>
          </div>
          <div class="col-3">
            <button class="btn btn-block btn-primary" @click="updateAwayPenalty(p)">Update</button>
          </div>
          <div class="col-3">
            <button class="btn btn-block btn-danger" @click="removeAwayPenalty(p)">Remove</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapOverlayData, mapTemplateOptions } from '../../utils/index'
  import * as action from '@/store/action-types'
  import TimeInputGroup from '../ui/time-input-group'

  export default {
    components: {TimeInputGroup},
    props: ['templateId'],
    data () {
      return {
        minutes: 2
      }
    },
    computed: {
      ...mapOverlayData({
        'direction': {default: 'up'},
        'isRunning': {default: false},
        'currentTimeMs': {default: 0},
        'homePenalties': {default: []},
        'awayPenalties': {default: []}
      }),
      ...mapTemplateOptions({
        'startTimeMs': {default: 0}
      })
    },
    watch: {
      isRunning: function () {
        this.localCurrentTimeUtc = this.direction === 'up' ? Date.now() - this.currentTimeMs : Date.now() + this.currentTimeMs
      },
      homePenalties: function (val) {
        this.$store.dispatch(action.OVERLAY_DATA, {
          templateId: this.templateId,
          channelIds: ['program', 'preview'],
          data: {homePenalties: val}
        })
      },
      awayPenalties: function (val) {
        this.$store.dispatch(action.OVERLAY_DATA, {
          templateId: this.templateId,
          channelIds: ['program', 'preview'],
          data: {awayPenalties: val}
        })
      }
    },
    methods: {
      newHomePenalty (duration) {
        duration = duration * 60 * 1000
        const startTimeMs = this.getCurrentTimeMs()
        const endTimeMs = this.direction === 'up' ? startTimeMs + duration : startTimeMs - duration
        console.debug('[penalty] adding penalty %d mins from %d to %d', duration / (60 * 1000), startTimeMs, endTimeMs)
        const penalties = [].concat(this.homePenalties).concat({startTimeMs, endTimeMs, duration})
        penalties.sort((a, b) => a.startTimeMs - b.startTimeMs || a.endTimeMs - b.endTimeMs)
        this.homePenalties = penalties
      },
      updateHomePenalty (penalty) {
        penalty.endTimeMs = this.direction === 'up' ? penalty.startTimeMs + penalty.duration : penalty.startTimeMs - penalty.duration
        const penalties = [].concat(this.homePenalties)
        penalties.sort((a, b) => a.startTimeMs - b.startTimeMs || a.endTimeMs - b.endTimeMs)
        this.homePenalties = penalties
      },
      removeHomePenalty (penalty) {
        const idx = this.homePenalties.indexOf(penalty)
        this.homePenalties.splice(idx, 1)
        this.homePenalties = [].concat(this.homePenalties)
      },
      newAwayPenalty (duration) {
        duration = duration * 60 * 1000
        const startTimeMs = this.getCurrentTimeMs()
        const endTimeMs = this.direction === 'up' ? startTimeMs + duration : startTimeMs - duration
        console.debug('[penalty] adding penalty %d mins from %d to %d', duration / (60 * 1000), startTimeMs, endTimeMs)
        const penalties = [].concat(this.awayPenalties).concat({startTimeMs, endTimeMs, duration})
        penalties.sort((a, b) => a.startTimeMs - b.startTimeMs || a.endTimeMs - b.endTimeMs)
        this.awayPenalties = penalties
      },
      updateAwayPenalty (penalty) {
        penalty.endTimeMs = this.direction === 'up' ? penalty.startTimeMs + penalty.duration : penalty.startTimeMs - penalty.duration
        const penalties = [].concat(this.awayPenalties)
        penalties.sort((a, b) => a.startTimeMs - b.startTimeMs || a.endTimeMs - b.endTimeMs)
        this.awayPenalties = penalties
      },
      removeAwayPenalty (penalty) {
        const idx = this.awayPenalties.indexOf(penalty)
        this.awayPenalties.splice(idx, 1)
        this.awayPenalties = [].concat(this.awayPenalties)
      },
      getCurrentTimeMs () {
        if (this.isRunning) {
          let newCurrentTimeMs
          if (this.direction === 'down') {
            newCurrentTimeMs = this.localCurrentTimeUtc - Date.now()
          } else {
            newCurrentTimeMs = Date.now() - this.localCurrentTimeUtc
          }
          if (newCurrentTimeMs < 0) {
            newCurrentTimeMs = 0
          }
          return newCurrentTimeMs
        } else {
          return this.currentTimeMs
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/floorball-scoreboard-penalty.vue